import React, { useEffect, useState } from 'react';

import { useI18n } from 'Hooks';

import { FieldWrapper, MultiInputWrapper } from './styles';
import Button from '../../Components-redesign/Button';
import { MultiInputs } from '../../Components-redesign/Fields/MultiInputs';
import TextInput from '../../Components-redesign/Fields/TextInput';
import Field from '../../Components-redesign/Form/Field';

interface Props {
  label: string;
  type: string;
  initialValue: any;
  handleSubmit: (value: any) => void;
}

const IntegrationFields: React.FunctionComponent<Props> = ({
  label,
  type,
  initialValue,
  handleSubmit,
}) => {
  const { t } = useI18n();
  const [value, setValue]: any = useState(initialValue);
  const [loading, setLoading]: any = useState(false);

  useEffect(() => {
    if (JSON.stringify(value) == JSON.stringify(initialValue)) {
      setLoading(false);
    }
  }, [initialValue]);

  const isDisabled =
    JSON.stringify(value) == JSON.stringify(initialValue) ||
    (initialValue.length == 0 && value.length == 0) ||
    loading;

  const onSubmit = () => {
    setLoading(true);
    handleSubmit(value);
  };

  const getFieldType = (type: string) => {
    switch (type) {
      case 'STRING':
        return (
          <FieldWrapper>
            <Field label={label}>
              <TextInput
                name={label}
                handleChange={(e) => setValue(e.target.value)}
                value={value as string}
              />
            </Field>

            <Button
              text={t('General.Submit')}
              handleClick={onSubmit}
              height="48px"
              width="100px"
              styleType="OK"
              disabled={isDisabled}
            />
          </FieldWrapper>
        );
      case 'NUMBER_MAP':
        return (
          <MultiInputWrapper>
            <MultiInputs
              title={label}
              labels={['ID', 'Value']}
              values={value as { id: string; value: string }[]}
              handleChange={(val) => setValue(val)}
            />
            <Button
              text={t('General.Submit')}
              handleClick={onSubmit}
              height="48px"
              width="80px"
              styleType="OK"
              disabled={isDisabled}
            />
          </MultiInputWrapper>
        );
      default:
        return (
          <FieldWrapper>
            <Field label={label}>
              <TextInput
                name={label}
                type="number"
                handleChange={(e) => setValue(e.target.value)}
                value={value as string}
              />
            </Field>

            <Button
              text={t('General.Submit')}
              handleClick={onSubmit}
              height="48px"
              width="100px"
              styleType="OK"
              disabled={isDisabled}
            />
          </FieldWrapper>
        );
    }
  };

  return getFieldType(type);
};

export default React.memo(IntegrationFields);
